jQuery(document).ready(function($){

	var faqTrigger = $('.cd-faq-trigger');
	
	//select a faq section 
	faqTrigger.on('click', function(event){
		event.preventDefault();
		$(this).next('.cd-faq-content').slideToggle(200).end().parent('li').toggleClass('content-visible');
	});
});

// Faq readmore
  
document.getElementById("show-more").addEventListener('click', function(){
  var items = document.querySelectorAll('.cd-faq-group li');
  for (var i = 5; i < items.length; i++){
    items[i].classList.add('show') ;
  }
  this.style.display = 'none';
  document.getElementById('show-less').style.display = 'block';
});

document.getElementById("show-less").addEventListener('click', function(){
  var items = document.querySelectorAll('.cd-faq-group li');
  for (var i = 5; i < items.length; i++){
    items[i].classList.remove('show') ;
  }
  this.style.display = 'none';
  document.getElementById('show-more').style.display = 'block';
});